import cx from 'classnames';
import * as React from 'react';
import type { IIconType } from '@duel/icon';
import DSXIcon from '../Icon';

export interface IHeaderProps {
	dsxIcon?: IIconType;
	value?: string;
	className?: string;
	isHidden?: boolean;
}

export default class Header extends React.Component<IHeaderProps> {
	public render() {
		const { isHidden, className, value, dsxIcon } = this.props;

		const classes = cx('', className);

		const IconEl = dsxIcon && (
			<span className="ml-2">
				<DSXIcon className="mr-2" style={dsxIcon} />
			</span>
		);

		const header = !isHidden && (
			<div className={classes}>
				<h1 className="flex items-center m-0">
					{IconEl}
					{value}
				</h1>
			</div>
		);
		return header;
	}
}
